import {css, html, LitElement} from 'lit';
import {customElement, property} from 'lit/decorators';
import {
  containerStyles,
  moduleSpacingStyles,
  normalizeStyles,
  typographyStyles,
} from '@webs/components-library/theming';
import { ifDefined } from 'lit/directives/if-defined.js';

@customElement('webs-cta-links')
export class CtaLinks extends LitElement {
  static styles = [
    normalizeStyles,
    containerStyles,
    typographyStyles,
    moduleSpacingStyles,
    css`
      :host {
        --module-dark-background: var(--color-base);
        --module-light-background: var(--color-light-grey);
      }

      .m-cta-links {
        background: var(--module-light-background);
      }

      .m-cta-links ::slotted([slot="title"]) {
        margin: 0 !important;
        padding-bottom: 0.6rem !important;
      }

      .m-cta-links p {
        color: var(--color-dark-grey);
        font-family: var(--font-family-base);
        font-size: 0.8rem!important;
        font-weight: var(--font-weight-base);
        line-height: 1.2rem!important;
        margin: 0;
        padding-bottom: 1.3rem!important;
      }

      .m-cta-links .links {
        padding-top: 1.5rem;
      }

      .m-cta-links--dark {
        background: var(--module-dark-background);
      }

      .m-cta-links--dark ::slotted([slot="title"]),
      .m-cta-links--dark p {
        color: var(--color-light-grey);
      }

      @media only screen and (max-width: 1175px) {
        .m-cta-links p {
          font-size: 0.75rem;
        }
      }

      @media only screen and (min-width: 768px) {
        .m-cta-links ::slotted([slot="title"]) {
          line-height: 2.4rem !important;
          padding-bottom: 1.6rem!important;
        }

        .m-cta-links p {
          font-size: 0.9rem !important;
          padding-bottom: 1.6rem !important;
        }
        .m-cta-links .links {
          padding-top: 0;
        }
      }
    `,
  ];

  @property({attribute: 'space-top'})
  spaceTop = 'm';

  @property({attribute: 'space-bottom'})
  spaceBottom = 'm';

  @property()
  id: string;

  @property()
  title = 'No matter who you are we can help you';

  @property()
  description: string;

  @property()
  theme = 'light';

  protected render(): unknown {
    return html`
      <section id="${ifDefined(this.id)}" class="m-cta-links ${this.spaceTop ? 'module_top-padding-' + this.spaceTop : ''} ${this.spaceBottom ? 'module_bottom-padding-' + this.spaceBottom : ''} ${this.theme ? 'm-cta-links--' + this.theme : ''}">
        <div part="container" class="container">
          <webs-grid-row>
            <webs-grid-column sm="5">
              <slot name="title"></slot>
              ${this.description ? html`<p>${this.description}</p>` : ''}
              <slot name="cta-with-avatar"></slot>
            </webs-grid-column>
            <webs-grid-column sm="6" sm-offset="1" lg="5" lg-offset="1">
              <div class="links">
                <slot name="link"></slot>
              </div>
            </webs-grid-column>
          </webs-grid-row>
        </div>
      </section>
    `;
  }
}
